import apiClient from "./apiClient";

export const tenantApi = {
  getAll: () => apiClient.get("/tenants"),
  getSirketler: () => apiClient.get("/tenants/sirketler"),
  sirketOlustur: (data) => apiClient.post("/tenants/sirketler", data),
  sirketGuncelle: (id, data) => apiClient.put(`/tenants/sirketler/${id}`, data),
  sirketSil: (id) => apiClient.delete(`/tenants/sirketler/${id}`),
  getMe: () => apiClient.get("/tenants/me"),
  subeAbonelikleriGetir: () => apiClient.get("/tenants/sube-abonelikleri"),
  getById: (id) => apiClient.get(`/tenants/${id}`),
  create: (data) => apiClient.post("/tenants", data),
  update: (id, data) => apiClient.put(`/tenants/${id}`, data),
  delete: (id) => apiClient.delete(`/tenants/${id}`),
  abonelikPaketleriGetir: () => apiClient.get("/tenants/abonelik-paketleri"),
  abonelikPaketiOlustur: (data) => apiClient.post("/tenants/abonelik-paketleri", data),
  abonelikPaketiGuncelle: (id, data) => apiClient.put(`/tenants/abonelik-paketleri/${id}`, data),
  abonelikRaporuGetir: (params) => apiClient.get("/tenants/abonelik-raporu", { params }),
  abonelikleriGetir: (id) => apiClient.get(`/tenants/${id}/abonelikler`),
  yillikAbonelikEkle: (id, data) => apiClient.post(`/tenants/${id}/abonelikler`, data),
  kullanicilariGetir: (id) => apiClient.get(`/tenants/${id}/kullanicilar`),
  kullaniciEkle: (id, data) => apiClient.post(`/tenants/${id}/kullanici-ekle`, data),
  kullaniciGuncelle: (kullaniciId, data) => apiClient.put(`/tenants/kullanici/${kullaniciId}`, data),
  kullaniciSil: (kullaniciId) => apiClient.delete(`/tenants/kullanici/${kullaniciId}`),
  sifreSifirla: (kullaniciId) => apiClient.post(`/tenants/kullanici/${kullaniciId}/sifre-sifirla`),
};
